import { StorageService } from '@src/app/services/storage.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrls } from '../core/config';
import { FeatureFlag } from '../core/models';
import { featureFlags } from '../core/Constants';

@Injectable({
  providedIn: 'root'
})
export class FeatureflagService {

  private readonly featureFlagUrl = ApiUrls.FeatureFlagUrl;

  constructor(private http: HttpClient, private storageService: StorageService) { }

  getFeatureFlags(): Observable<FeatureFlag[]> {
    return this.http.get<FeatureFlag[]>(`${this.featureFlagUrl}`);
  }

  getFeatureFlag(featureName: string): Observable<boolean> {
    return this.http.get<boolean>(`${this.featureFlagUrl}/${encodeURIComponent(featureName)}`);
  }

  isActive(flagName: string): boolean {
    const storedFlags = this.storageService.get(featureFlags);
    if (!storedFlags) {
      return false;
    }

    const response = JSON.parse(storedFlags) as FeatureFlag[];
    const flag = response.find(candidate => candidate.name === flagName);
    return flag?.isEnabled === true;
  }

}
